/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as moment from "moment";
import { TableWrapper } from "../../../shared/layout";
import { templateStrings } from "../../../Constant";
import { dayWiseBreakDownCollectionListAction } from "../../../redux/action-creators/dayWiseBreakDownActionCreator";
import { setTokenExpired } from "../../../redux/actions/authActions";
import { setNotificationMessage } from "../../../redux/actions/notificationAction";

class VehicleDetail extends React.Component {
  constructor(props) {
    super(props);
    const m = moment(new Date());
    this.state = {
      showHeaderButton: true,
      pageNo: 0,

      isUserAViewer: false,
      date: m,
      todaySelectable: true,
      backdrop: false,
      content: [],
      rowsPerPage: 10,
      selected: [],
    };
    this.vehicleDetailGetList = this.vehicleDetailGetList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.handleColumnAction = this.handleColumnAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.vehicleDetailGetList();
  }

  componentDidUpdate(prevProps) {
    const { operatorFilter, cityFilter, selectedDateFilter } = this.props;
    if (prevProps && (
      (prevProps.operatorFilter !== operatorFilter)
      || (prevProps.cityFilter !== cityFilter)
      || (prevProps.selectedDateFilter !== selectedDateFilter))) {
      this.vehicleDetailGetList();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleAction() {
    // eslint-disable-next-line no-console
    console.log("action clicked");
  }

  handleColumnAction(vehicleDetails, column) {
    const { history } = this.props;
    if (column === "walletUsage") {
      history.push("/collection-view/details/balance-spent", vehicleDetails);
    } else {
      history.push("/collection-view/details/balance-loaded", vehicleDetails);
    }
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.vehicleDetailGetList();
      },
    );
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.setState({ selected: [] });
        this.vehicleDetailGetList();
      }
    });
  };

  /**
   * API call to get data.
   * @param pageNo current page number
   */
  vehicleDetailGetList() {
    const {
      fetchDayWiseBreakDown, busNumber, selectedDateFilter,
      selectedOperation, operatorFilter, cityFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    fetchDayWiseBreakDown({
      pageNo,
      pageSize: rowsPerPage,
      busNumber,
      dateFilter: selectedDateFilter,
      operartionType: selectedOperation,
      operatorId: operatorFilter,
      cityId: cityFilter,
      sortBy,
    });
  }

  render() {
    const { headerLoader, content, totalItems } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="fromDate"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateStrings.operatorViewDayWise}
          selectionAllowed={false}
          handleAction={this.handleAction}
          handleColumnAction={this.handleColumnAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.BreakDown
        && state.BreakDown.dayWiseBreakDownCollection
        && state.BreakDown.dayWiseBreakDownCollection.items)
      || [],
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    selectedDateFilter: state.DateFilter.selectedDateFilter,
    operatorFilter: state.Operators.selectedOperator,
    cityFilter: state.Cities.selectedCity,
    selectedOperation: state.OperationType.selectedOperationType,
    totalItems:
      (state
        && state.BreakDown
        && state.BreakDown.dayWiseBreakDownCollection
        && state.BreakDown.dayWiseBreakDownCollection.totalItems)
      || 0,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchDayWiseBreakDown: (params) => {
    dispatch(dayWiseBreakDownCollectionListAction(params));
  },
  initiateNotification: (value) => {
    dispatch(setNotificationMessage(value));
  },
  setTokenExpired: (value) => {
    dispatch(setTokenExpired(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleDetail));
